import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { createFolderCommand } from '../createFolder/createFolderCommand';
import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';
import CommandStrings from '../Commands.resx';
import {
  createWordCommand,
  createExcelCommand,
  createPowerPointCommand,
  createOneNoteCommand,
  createExcelSurveyCommand,
  createFormForExcelCommand,
  createVisioCommand,
  createBohemiaCommand,
  createPragueCommand
} from '../createDocument/createDocumentCommand';

export const newCommand: ICommand = {
  key: new Facet('newCommand').id,
  automationId: 'newCommand',
  name: CommandStrings.Create,
  title: CommandStrings.CreateCommandAriaLabel,
  iconProps: {
    iconName: 'CalculatorAddition'
  },
  subMenuProps: {
    items: [
      createFolderCommand,
      { name: '-', key: 'divider_1', itemType: ContextualMenuItemType.Divider },
      createWordCommand,
      createExcelCommand,
      createPowerPointCommand,
      createOneNoteCommand,
      createExcelSurveyCommand,
      createFormForExcelCommand,
      createVisioCommand,
      createBohemiaCommand,
      createPragueCommand
    ]
  }
};
